package com.yendo.mx.utils

import com.yendo.mx.models.RestauranteFirebase
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import com.yendo.mx.utils.getAhora

fun validarRestauranteAbierto(restaurante: RestauranteFirebase): Boolean {
    // 1. Verificamos los bloqueos de emergencia y visibilidad
    if (!restaurante.operacion.visible || !restaurante.operacion.activoComercio) return false // 🚀 ADUANA MAESTRA DUAL
    if (restaurante.operacion.bloqueadoPorAdmin) return false
    if (restaurante.operacion.pausadoManualmente) return false

    // 🚀 BANDERAZO NUBE 0ms: Si el estatus viene resuelto desde Google Cloud, confiamos al 100%
    if (restaurante.estaAbiertoCloud != null) {
        return restaurante.estaAbiertoCloud
    }

    // 2. Obtenemos la hora actual del dispositivo
    val ahora = Instant.fromEpochMilliseconds(getAhora()).toLocalDateTime(TimeZone.currentSystemDefault())

    // 3. Obtenemos el listado de franjas para el día de hoy
    val horarios = restaurante.horarios ?: return false
    val franjasDeHoy = when(ahora.dayOfWeek) {
        kotlinx.datetime.DayOfWeek.MONDAY -> horarios.lunes
        kotlinx.datetime.DayOfWeek.TUESDAY -> horarios.martes
        kotlinx.datetime.DayOfWeek.WEDNESDAY -> horarios.miercoles
        kotlinx.datetime.DayOfWeek.THURSDAY -> horarios.jueves
        kotlinx.datetime.DayOfWeek.FRIDAY -> horarios.viernes
        kotlinx.datetime.DayOfWeek.SATURDAY -> horarios.sabado
        kotlinx.datetime.DayOfWeek.SUNDAY -> horarios.domingo
    }

    // 4. Si no hay franjas, está cerrado
    if (franjasDeHoy.isEmpty()) return false

    val minutosActuales = (ahora.hour * 60) + ahora.minute

    // 5. Verificamos si los minutos actuales entran en ALGUNA de las franjas activas
    return franjasDeHoy.any { franja ->
        if (!franja.activo) return@any false
        if (franja.abre.isBlank() || franja.cierra.isBlank()) return@any false

        try {
            val (horaAbre, minAbre) = franja.abre.split(":").map { it.toInt() }
            val (horaCierra, minCierra) = franja.cierra.split(":").map { it.toInt() }

            val minutosApertura = (horaAbre * 60) + minAbre
            val minutosCierre = (horaCierra * 60) + minCierra

            minutosActuales in minutosApertura..minutosCierre
        } catch (e: Exception) {
            false
        }
    }
}
